import { createSelector } from 'reselect';

export const paymentMethodsSelector = (state) => state.get('paymentMethods');

export const paymentMethodsByIdSelector = createSelector(
  paymentMethodsSelector,
  (paymentMethods) => paymentMethods.get('byId')
);

export const paymentMethodsAllIdsSelector = createSelector(
  paymentMethodsSelector,
  (paymentMethods) => paymentMethods.get('allIds')
);

export const paymentMethodsByProjectIdSelector = createSelector(
  paymentMethodsSelector,
  (paymentMethods) => paymentMethods.get('byProjectId')
);
